export default __webpack_public_path__ + "static/media/olivine33.af09d911.png";